import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'empathy-copy-choices-confirmation',
  templateUrl: 'copy-choices-confirmation.component.html'
})
export class CopyChoicesConfirmationComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<CopyChoicesConfirmationComponent>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
    this.dialogRef.disableClose = true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
